import { MessageCircle, X } from 'lucide-react';

export default function ShaktiBotLauncher({ hidden, onToggle }) {
    return (
        <button
            type="button"
            aria-label={hidden ? 'open support bot' : 'close support bot'}
            onClick={onToggle}
            className="ml-auto flex h-14 w-14 items-center justify-center rounded-full bg-primary text-white shadow-[0_14px_32px_rgba(181,38,25,0.32)] transition-transform duration-300 hover:scale-105"
        >
            {hidden ? <MessageCircle className="h-6 w-6" /> : <X className="h-6 w-6" />}
        </button>
    );
}
